import React, { useEffect, useState, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import backImage from "../../../assets/icons/arrow-back-black.svg";
import ProgressIndicator from "./ProgressIndicator";
import SecureImage from "../../../components/common/SecureImage";
import MaleActive from "../../../assets/images/ic_male_active.png";
import FemaleActive from "../../../assets/images/ic_female_active.png";
import { logEventWithData } from "../../../app/eventSlice";
import { getProvider, setStateFromPayload, checkConfig } from "../navigoSlice";
import { useHistory } from "react-router";
import BackButton from "../../../components/common/BackButton";
import NavigoFinalSection from "./navigoFinalSection";
import BookingDetailsSheet from "./BookingDetailsSheet";
import { IonContent, IonPage, useIonViewWillEnter } from "@ionic/react";
import AddressBook from "../../address/newIndex";
import { getFamilyData, getPriceForFamily } from "../../familyInfo/familySlice";
import { clearPricesForFamily } from "../../familyInfo/familySlice";
export default function BookingForSection({ providerData: provider }) {
  const navigoStore = useSelector((store) => store.navigo);
  // const location = useLocation();
  // const services = location?.state?.service;
  const dispatch = useDispatch();
  const pricesForFamily = useSelector(
    (state) => state.familyInfo.pricesForFamily,
  );
  const patientProfile = useSelector(
    (store) => store.login.user?.patientProfile,
  );
  const familyStore = useSelector((store) => store.familyInfo);
  const [finalPage, setFinalPage] = useState(false);
  const [familyMember, setFamilyMember] = useState();
  const [memberRelation, setMemberRelation] = useState(0);
  const history = useHistory();
  const [selfPrice, setSelfPrice] = useState(null);
  // const [price, setPrice] = useState(0);
  const [selectedMemberId, setSelectedMemberId] = useState(null);
  const [hasUserSelected, setHasUserSelected] = useState(false);
  const [addressBook, setAddressBook] = useState(false);
  const [loading, setLoading] = useState(false);
  const priceFetchedRef = useRef(false);
  const {
    isForFamily,
    familyMemberSelected,
    familyMemberSelectedData,
    currentServices,
    familyMembers,
    isUserSelectedFamily,
    currentSelectedService: service,
    currentSelectedPlan: planId,
    isCmpBooking,
  } = navigoStore.ui;
  const {
    loadedFamily,
    loadedRelation,
    fetchingFamily,
    fetchingRelations,
    familyData,
    relations,
    bookingFor,
    isPriceFetched,
  } = familyStore;

  const RELATIONS = [
    { code: 1, value: "Father" },
    { code: 2, value: "Father-in-law" },
    { code: 3, value: "Mother" },
    { code: 4, value: "Mother-in-law" },
    { code: 5, value: "Spouse" },
    { code: 6, value: "Daughter (below 18 years)" },
    { code: 7, value: "Daughter (above 18 years)" },
    { code: 8, value: "Son (below 18 years)" },
    { code: 9, value: "Son (above 18 years)" },
    { code: 10, value: "Others" },
  ];

  useEffect(() => {
    if (bookingFor && isPriceFetched) {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Reset selection when service changes
    setHasUserSelected(false);
    setSelectedMemberId(null);

    dispatch(
      setStateFromPayload({
        familyMemberSelected: null,
        familyMemberSelectedData: {},
        isUserSelectedFamily: false,
      }),
    );
  }, [service?.serviceId]);

  useEffect(() => {
    if (patientProfile?.id && pricesForFamily?.[patientProfile.id]) {
      const price =
        pricesForFamily[patientProfile.id]?.serviceModeDetails?.[0]
          ?.discountedPrice;

      if (price !== undefined) {
        setSelfPrice(price);
      }
    }
  }, [pricesForFamily, patientProfile?.id]);

  function getRelationByCode(code) {
    return RELATIONS.find((relation) => relation.code === code) || null;
  }

  const handleAvailNow = (familyMember) => {
    const matchedMember = familyData.find(
      (member) => Number(member.memberPatientId) === Number(familyMember),
    );

    if (matchedMember) {
      setMemberRelation(matchedMember.relation);
    }
    if (service?.serviceModeDetails[0]?.modeName != "Home sample") {
      setFinalPage(true);
    }
    setFamilyMember(familyMember === -1 ? patientProfile.id : familyMember);
    if (service?.serviceModeDetails[0]?.modeName === "Home sample") {
      history.push({
        pathname: "/select-address",
        state: {
          addressOnly: true,
          service,
          planId,
          familyMember: familyMember === -1 ? patientProfile.id : familyMember,
          memberRelation: matchedMember ? matchedMember.relation : 0,
          price: selectedPrice,
        },
      });
    }
  };
  useIonViewWillEnter(() => {
    if (!priceFetchedRef.current) {
      priceFetchedRef.current = true;

      setHasUserSelected(false);
      setSelectedMemberId(null);

      dispatch(
        setStateFromPayload({
          familyMemberSelected: null,
          familyMemberSelectedData: {},
          isUserSelectedFamily: false,
        }),
      );

      continueAvailNow(service);
    }
  });

  const getPriceForMember = (memberId) => {
    return (
      pricesForFamily?.[memberId]?.serviceModeDetails?.[0]?.discountedPrice || 0
    );
  };

  const continueAvailNow = async (service) => {
    setLoading(true);

    try {
      const resultAction = await dispatch(getFamilyData());
      const familyMembers = resultAction?.payload?.data || [];

      const pricePromises = [];

      const selfBody = {
        memberPatientId: patientProfile.id,
        memberRelation: 0,
        patientId: patientProfile.id,
        planId: service.planId,
        serviceId: service.serviceId,
        serviceMode: service.serviceModeDetails[0].modeName,
      };

      pricePromises.push(dispatch(getPriceForFamily(selfBody)));

      // Family pricing
      for (const fm of familyMembers) {
        const sameRelationPIds = familyMembers
          .filter((member) => member.relation === fm.relation)
          .map((member) => member.memberPatientId);

        const body = {
          memberPatientId: fm.memberPatientId,
          memberRelation: fm.relation,
          patientId: fm.patientId,
          planId: service.planId,
          serviceId: service.serviceId,
          serviceMode: service.serviceModeDetails[0].modeName,
          sameRelationPIds,
        };

        pricePromises.push(dispatch(getPriceForFamily(body)));
      }

      await Promise.all(pricePromises);

      if (isCmpBooking) {
        // CMP / avail care program: no provider selection. Fetch the
        // avail-specific booking config so the slots page can use its
        // min/max booking days.
        await dispatch(
          checkConfig({
            patientId: patientProfile.id,
            planId: service.planId,
            program: "avail",
          }),
        );
      } else if (service?.serviceModeDetails?.[0]?.modeName !== "Home sample") {
        const providerBody = {
          cityMatch: [],
          landmarkMatch: [],
          languageMatch: [],
          pageNum: 0,
          pageSize: 0,
          patientId: patientProfile.id,
          planId: planId,
          serviceId: service?.serviceId,
          serviceMode: service?.serviceModeDetails?.[0]?.modeName,
          stateMatch: [],
        };

        await dispatch(getProvider(providerBody));
      }
    } catch (error) {
      console.error("Failed to fetch family/pricing", error);
    } finally {
      setLoading(false);
    }
  };

  const selectedPrice =
    selectedMemberId === -1
      ? selfPrice ?? 0
      : pricesForFamily?.[selectedMemberId]?.serviceModeDetails?.[0]
          ?.discountedPrice ?? 0;

  const selfServiceDetails = pricesForFamily?.[patientProfile?.id]?.serviceModeDetails?.[0];
  const selfCanAvail = selfServiceDetails?.canAvailService;
  const selfReason = selfServiceDetails?.nonServiceAvailabilityReason;
  const isSelfDisabled = selfCanAvail === false;

  return (
    <IonPage>
      {loading && (
        <div className="booking-loader-blur">
          <div className="loader-spinner"></div>
        </div>
      )}
      <IonContent>
        {" "}
        <>
          {finalPage ? (
            <NavigoFinalSection
              familyMember={familyMember}
              provider={provider}
              memberRelation={memberRelation}
              service={service}
              price={selectedPrice}
              isCmp={isCmpBooking}
            />
          ) : addressBook ? (
            <AddressBook
              familyMember={familyMember}
              booking={true}
              service={service}
              memberRelation={memberRelation}
              price={selectedPrice}
            />
          ) : (
            <div
              className="navigo-container-screen-2"
              style={{
                paddingBottom: "calc(180px + var(--ion-safe-area-bottom, 0px))",
              }}
            >
              <div className="navigo-container-screen-2-header">
                <img
                  src={backImage}
                  alt="icon"
                  onClick={() => {
                    history.goBack();
                    dispatch(
                      setStateFromPayload({
                        currScreen: 1,
                        familyMemberSelected: isForFamily
                          ? familyMemberSelected
                          : -2,
                        familyMemberSelectedData: isForFamily
                          ? familyMemberSelectedData
                          : {},
                        addressSelected: null,
                      }),
                    );
                  }}
                />
                {/* <BackButton></BackButton> */}
                <div className="navigo-container-screen-2-main overflow-y-auto max-h-[calc(100vh-180px)] px-4">
                  <span className="font-semibold text-base leading-7 text-lightblack">
                    {familyData.firstName}
                  </span>
                </div>
              </div>
              <div className="navigo-container-screen-2-main">
                <div className="navigo-container-screen-2-main-mid">
                  <ProgressIndicator isInput={false} />
                </div>
                <p className="navigo-container-screen-2-main-mid-2">
                  Booking for
                </p>
                <div className="navigo-container-screen-2-main-family-list">
                  <div
                    className={`navigo-container-screen-2-main-family-list-ele ${
                      isSelfDisabled
                        ? "opacity-50 cursor-not-allowed"
                        : "cursor-pointer"
                    }`}
                    onClick={() => {
                      if (isSelfDisabled) return;
                      setHasUserSelected(true);
                      setSelectedMemberId(-1);
                      dispatch(
                        setStateFromPayload({
                          familyMemberSelected: 0,
                          familyMemberSelectedData: { ...patientProfile },
                        }),
                      );
                    }}
                  >
                    <div className="text-xs font-semibold text-[#97144D] mr-2 min-w-[40px]">
                      ₹{selfPrice}
                    </div>
                    <SecureImage
                      src={patientProfile.profileImage}
                      defaultImage={
                        patientProfile.gender === 1 ? FemaleActive : MaleActive
                      }
                    />
                    <div
                      className={`navigo-container-screen-2-main-family-list-ele-mid general-disabled-color-class}`}
                    >
                      <p className="navigo-container-screen-2-main-family-list-ele-mid-top">{`${
                        patientProfile.firstName
                      } ${
                        patientProfile.lastName ? patientProfile.lastName : ""
                      }`}</p>
                      <p className="navigo-container-screen-2-main-family-list-ele-mid-bottom">
                        {patientProfile.age ? `${patientProfile.age}, ` : ""}
                        self
                      </p>
                      {isSelfDisabled && selfReason && (
                        <p className="text-xs text-red-600 mt-1">
                          {selfReason}
                        </p>
                      )}
                    </div>

                    <input
                      type="radio"
                      style={{ accentColor: "#97144D" }}
                      checked={hasUserSelected && selectedMemberId === -1}
                      onChange={() => {
                        if (isSelfDisabled) return;
                        setHasUserSelected(true);
                        setSelectedMemberId(-1);
                        dispatch(
                          setStateFromPayload({
                            familyMemberSelected: 0,
                            familyMemberSelectedData: { ...patientProfile },
                          }),
                        );
                      }}
                      disabled={isSelfDisabled}
                    />
                  </div>
                  {familyData.map((fd, index) => {
                    const serviceDetails =
                      pricesForFamily?.[fd.memberPatientId]
                        ?.serviceModeDetails?.[0];
                    const price = serviceDetails?.discountedPrice;
                    const canAvail = serviceDetails?.canAvailService;
                    const reason = serviceDetails?.nonServiceAvailabilityReason;

                    const isDisabled = canAvail === false;

                    return (
                      <div
                        key={fd.id}
                        className={`navigo-container-screen-2-main-family-list-ele ${
                          isDisabled
                            ? "opacity-50 cursor-not-allowed"
                            : "cursor-pointer"
                        }`}
                        onClick={() => {
                          if (isDisabled) return;
                          setHasUserSelected(true);
                          setSelectedMemberId(fd.memberPatientId);
                          dispatch(
                            setStateFromPayload({
                              familyMemberSelected: fd.memberPatientId,
                              familyMemberSelectedData: { ...fd },
                              isUserSelectedFamily: true,
                            }),
                          );
                        }}
                      >
                        <div className="text-xs font-semibold text-[#97144D] mr-2 min-w-[40px]">
                          ₹{price}
                        </div>
                        <SecureImage
                          src={fd.profilePicURL}
                          defaultImage={
                            fd.gender === 1 ? FemaleActive : MaleActive
                          }
                        />
                        <div
                          className={`navigo-container-screen-2-main-family-list-ele-mid general-disabled-color-class}`}
                        >
                          <p className="navigo-container-screen-2-main-family-list-ele-mid-top">{`${
                            fd.firstName
                          } ${fd.lastName || ""}`}</p>
                          <p className="navigo-container-screen-2-main-family-list-ele-mid-bottom">
                            {fd.age ? `${fd.age}, ` : ""}
                            {getRelationByCode(fd.relation)?.value ||
                              "Relation"}
                          </p>
                          {/* 🛑 Show reason if unavailable */}
                          {isDisabled && reason && (
                            <p className="text-xs text-red-600 mt-1">
                              {reason}
                            </p>
                          )}
                        </div>
                        <input
                          type="radio"
                          style={{ accentColor: "#97144D" }}
                          checked={
                            hasUserSelected &&
                            selectedMemberId === fd.memberPatientId
                          }
                          onChange={() => {
                            if (isDisabled) return;
                            setHasUserSelected(true);
                            setSelectedMemberId(fd.memberPatientId);
                            dispatch(
                              setStateFromPayload({
                                familyMemberSelected: fd.memberPatientId,
                                familyMemberSelectedData: { ...fd },
                                isUserSelectedFamily: true,
                              }),
                            );
                          }}
                          disabled={isDisabled}
                        />
                      </div>
                    );
                  })}
                </div>
              </div>
              <div className="navigo-container-screen-2-bottom has-booking-floater">
                {
                  <p
                    onClick={() => {
                      dispatch(
                        logEventWithData({
                          action: "navigo_add_family",
                          data: { is_app_event: true },
                        }),
                      );
                      history.push({
                        pathname: "/family",
                        state: {
                          isMedicine: true,
                          isPath: true,
                          path: "/navigo",
                        },
                      });
                      // dispatch(
                      //   setStateFromPayload({
                      //     openFamily: true,
                      //     openAddFamily: true,
                      //     openFamilyProfile: false,
                      //   })
                      // );
                    }}
                  >
                    Add/Edit a family member
                  </p>
                }
                <button
                  disabled={!hasUserSelected}
                  onClick={() => handleAvailNow(selectedMemberId)}
                >
                  Continue
                </button>
              </div>
            </div>
          )}
          {!finalPage && !addressBook && <BookingDetailsSheet />}
        </>
      </IonContent>
    </IonPage>
  );
}
